<template>
  <div class="mask" @click="closeShareMask">
    <img src="../assets/share.png" alt="" srcset="" />
  </div>
</template>
<script>
import wx from "jweixin-module";
import { HERF } from "@/utils/tool";
export default {
  props: {
    id: "",
    type: "", //帖子2列表 1详情  3五行详情分析
    shareMask:false,
    des:'',
    shareImg:''
  },
  methods: {
    closeShareMask() {
      this.$emit("closeShareMask");
    },
    jsSdk() {
      console.log(this.shareImg,'--------------');
      const u = navigator.userAgent;
      let that = this;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let url = "";
      if (isiOS) {
        url = window.location.href.split("#")[0];
        // url = window.location.href;
      } else {
        url = window.location.href;
      }

      this.api.jsSdk({ url }).then((res) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
        });
        let user = localStorage.getItem("user");
        if (user) {
          user = JSON.parse(user);
        } else {
          user = "";
        }
        let usercode = user ? user.account : "";

        let u = "#" + window.location.href.split("#")[1];
        // u = window.location.href.split("#")[0] + u;

        if (that.type != 3) {
          u = HERF + "/h5/#/postDetails";
          if (usercode) {
            u = u + "?usercode=" + usercode + "&id=" + that.id + '&share=1';
          } else {
            u = HERF + "/h5/#/postDetails?id=" + that.id + '&share=1';
          }
        } else {
          u = HERF + "/h5/#/wx";
          if (usercode) {
            u = u + "?usercode=" + usercode + '&share=1';
          }
        }

        // console.log(u, "-----------shareurl----------");
        
        let des = this.des ? this.des : '';
        // console.log(des,'---------');
        wx.ready(function() {
          var title = "可以测";
          // var myurl = url;
          // var myurl = 'http://keyiche.anagelink.cn/h5';
          var imgUrl = HERF + "/backstage/kycx.png";
          //分享给朋友
          wx.updateAppMessageShareData({
            title: "可以测社区", // 分享标题
            desc: des, // 分享描述
            link: u, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            },
          });
          wx.updateTimelineShareData({
            title: "可以测社区", // 分享标题
            desc: des, // 分享描述
            link: u, // 分享链接
            link: url, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            },
          });

          wx.error((res) => {
            console.log(res);
          });
          // TODO
        });
      });
    },
  },
  data() {
    return {};
  },
  created() {
    // this.jsSdk();
  },
  watch: {
    shareMask(d){
      // if(d){
      //   this.jsSdk()
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}
</style>
